<script setup lang="ts">
import ContentContainer from '@/components/layout/ContentContainer.vue';
import Goals from '@/components/goals/Goals.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';
</script>

<template>
  <ContentContainer class="goals-container">
    <ContentColumn class="goals-component">
      <Goals :homepage="false" />
    </ContentColumn>
  </ContentContainer>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.goals-container {
  background-color: var(--colour-off-white);
  z-index: 101;
  position: relative;
}
.goals-component {
  :deep(.column-main) {
    @include screen.grid(12, 8, 4);
  }
}
</style>
